<template>
  <ElSelect
    v-bind="$attrs"
    :value="value"
    multiple
    filterable
    remote
    v-on="$listeners"
    @input="handleInput"
  >
    <slot :data="finalData" />
  </ElSelect>
</template>

<script>
export default {
  name: 'FilterableElSelect',
  props: {
    value: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      cachedData: [],
      finalData: [],
    };
  },
  watch: {
    data(val) {
      if (!val.length) this.finalData = [];
      else {
        this.computeFinalData();
      }
    },
  },
  methods: {
    handleInput(selectedItems) {
      this.handleCache(selectedItems);

      this.$emit('input', selectedItems);
    },
    // Concat data and cached data beside removeing duplicate data between them
    computeFinalData() {
      const findItem = searchId => this.data.find(({ id }) => searchId === id);

      this.finalData = this.data.concat(
        this.cachedData.filter(({ id }) => !findItem(id)),
      );
    },
    handleCache(selectedItems) {
      this.cache(selectedItems);
      // Concat cache and data and return it as finalData
      this.computeFinalData();
    },
    cache(selectedItems) {
      // Add selectedItems to the cache
      this.cachedData = this.cachedData.concat(
        selectedItems
          .filter(item => !this.cachedData.find(({ id }) => item === id))
          .map(item => {
            return this.data.find(({ id }) => id === item);
          }),
      );
    },
  },
};
</script>
